import Quill from 'quill';

const ListItemBlot = Quill.import('formats/list/item');
const Parchment = Quill.import('parchment');

const customFontFamilyAttributor = new Parchment.Attributor.Style(
  'custom-family-attributor',
  'font-family',
);
const customSizeAttributor = new Parchment.Attributor.Style(
  'custom-size-attributor',
  'font-size',
);
const customColorAttributor = new Parchment.Attributor.Style(
  'custom-color-attributor',
  'color',
);

// Custom implementation of list items
// to apply the style of the first child of the <li> to the <li> itself
// to fix color and font-size of the list bullets
class CustomListItem extends ListItemBlot {
  optimize(context?) {
    super.optimize(context);

    if (this.children.length >= 1) {
      const child = this.children.head;
      const attributes = child?.attributes?.attributes;

      if (attributes && Object.keys(attributes).length > 0) {
        Object.values(attributes).forEach((element: any) => {
          const name = element.keyName;
          const value = element.value(child.domNode);

          if (name === 'color') {
            super.format('custom-color-attributor', value);
          } else if (name === 'font-family') {
            super.format('custom-family-attributor', value);
          } else if (name === 'font-size') {
            super.format('custom-size-attributor', value);
          }
        });
      } else {
        super.format('custom-color-attributor', false);
        super.format('custom-family-attributor', false);
        super.format('custom-size-attributor', false);
      }
    }
  }
}

Quill.register(customColorAttributor, true);
Quill.register(customFontFamilyAttributor, true);
Quill.register(customSizeAttributor, true);

export default CustomListItem;
